import { NavigationGroup } from "./navigation-item.model";

export const DELIVERY_NAVIGATION_ITEMS: NavigationGroup[] = [
  {
    items: [
      { title: 'nav.items.dashboard', icon: 'bi bi-house', link: '/' },
    ]
  },
  {
    groupTitle: 'nav.groups.delivery',
    items: [
      { title: 'nav.items.drivers', icon: 'bi bi-person-badge', link: '/drivers' },
      { title: 'nav.items.delivery_zones', icon: 'bi bi-map', link: '/zones' }
    ]
  },
  {
    groupTitle: 'nav.groups.orders',
    items: [
      { title: 'nav.items.delivery_orders', icon: 'bi bi-box2', link: '/orders' }
    ]
  },
  {
    groupTitle: 'nav.groups.contact_us',
    items: [
      { title: 'nav.items.about_us', icon: 'bi bi-info-circle', link: '/about-us' },
      { title: 'nav.items.terms', icon: 'bi bi-book', link: '/terms-and-conditions' },
      { title: 'nav.items.privacy', icon: 'bi bi-file-earmark-lock', link: '/privacy-policy' }
    ]
  },
  {
    items: [
      { title: 'nav.items.logout', icon: 'bi bi-box-arrow-right', link: '/login' }
    ]
  }
];
